import React from 'react'
import { Link } from 'react-router-dom'
import Img from '../../assets/images/insurance-benefits.webp'

function Take() {
  return (
    <>
        <section className="about-two" style={{ backgroundImage: "url(assets/images/background/about-two-bg-1-1.jpg)"}} >
            <div className="container">
                <div className="row gutter-y-60">
                <div className="col-md-12 col-lg-6 d-flex">
                    <div className="my-auto">
                    <div className="about-two__content">
                        <div className="sec-title text-start">
                        <p className="sec-title__tagline">Insurance Benefits</p>
                        
                        <h3 className="sec-title__title">
                            Take our better insurance benefits opportunity
                        </h3>
                       
                        </div>
                        
                        <ul className="list-unstyled about-two__list">
                        <li>
                            <i className="fas fa-check" />
                            <div className="about-two__list__content">
                            <h3 className="about-two__list__title">
                                Provides Protection
                            </h3>
                            
                            <p className="about-two__list__text">
                                Insurance coverage does reduce the impact of loss that on
                                bears in perilous situations. It provides monetary
                                reimbursement
                            </p>
                            
                            </div>
                            
                        </li>
                        <li>
                            <i className="fas fa-check" />
                            <div className="about-two__list__content">
                            <h3 className="about-two__list__title">
                                Provides Certainty Risk Sharing
                            </h3>
                            
                            <p className="about-two__list__text">
                                Demoralized by the charms of pleasure the moment desires
                                they they cannot foresee the pain and trouble that bound
                            </p>
                            
                            </div>
                            
                        </li>
                        <li>
                            <i className="fas fa-check" />
                            <div className="about-two__list__content">
                            <h3 className="about-two__list__title">
                                Economic Growth Capital Generation
                            </h3>
                            
                            <p className="about-two__list__text">
                                The fund generated from the various premiums acts as a
                                pooled investment for the insurance company insurers
                            </p>
                            
                            </div>
                            
                        </li>
                        </ul>
                        
                    </div>
                    
                    </div>
                    
                </div>
                
                <div className="col-md-12 col-lg-6">
                    <div className="about-two__image">
                    <img src={Img} className="img-fluid" alt="" />
                    </div>
                   
                </div>
                
                </div>
                
            </div>
        </section>

       
    </>
  )
}

export default Take